@if (shouldUpload()) {
  <app-upload
    [disabled]="disabled()"
    [dropzoneTemplateRef]="dropzoneTemplateRef"
    [multi]="false"
    [uploadFn]="uploadFn"
    [maxFileSize]="maxFileSize()"
    [allowedMimeTypes]="allowedMimeTypes()" />

  <ng-template
    #dropzoneTemplateRef
    let-maxFileSize="maxFileSize"
    let-pending="pending">
    @if (!pending) {
      <app-multimedia-choose-or-upload-dropzone
        (multimediaLibraryClickEvent)="handleMultimediaLibraryClickEvent()"
        (sendFileClickEvent)="handleSendFileClickEvent()"
        [maxFileSize]="maxFileSize" />
    } @else {
      <div class="mx-auto size-44">
        <app-multimedia-tile mode="loading" />
      </div>
    }
  </ng-template>
}

@if (shouldPreview()) {
  <div class="flex aspect-square min-h-44 min-w-44">
    @if (chosenId() | adminFetchMultimediaById | async; as multimedia) {
      <div
        [style.width.%]="100"
        [style.height.%]="100"
        [style.max-height.px]="multimedia.height"
        [style.max-width.px]="multimedia.width">
        <app-multimedia-tile
          [info]="false"
          [type]="multimedia.type"
          [alt]="multimedia.alt"
          [filename]="multimedia.filename"
          [size]="multimedia.size"
          [previewUrl]="multimedia.previewUrl"
          [extension]="multimedia.extension"
          (removeClickEvent)="handleRemoveClickEvent()"
          mode="remove" />
      </div>
    } @else {
      <app-spinner-filled />
    }
  </div>
}

<p-drawer
  [(visible)]="imageExplorerVisibility"
  appDrawerSidebar
  position="right"
  size="xxl">
  <ng-template #header>
    <app-drawer-title>Biblioteka mediów</app-drawer-title>
  </ng-template>

  <ng-template #content>
    @if (imageExplorerVisibility) {
      <app-multimedia-choose-single
        [allowedMultimediaTypes]="allowedMultimediaTypes()"
        (confirmSelectedEvent)="handleConfirmSelectedEvent($event)" />
    }
  </ng-template>
</p-drawer>
